import { Content } from '@prismicio/client';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { SliceComponentProps } from '@prismicio/react';

/**
 * Props for `SocialMedia`.
 */
export type SocialMediaProps = SliceComponentProps<Content.SocialMediaSlice>;

/**
 * Component for "SocialMedia" Slices.
 */
const SocialMedia = ({ slice }: SocialMediaProps): JSX.Element => {
  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="flex items-center gap-4"
    >
      {slice.primary.media.map((media, index) => (
        <PrismicNextLink
          key={`media_${index.toString()}`}
          field={media.url}
          className="hover:opacity-80 transition-opacity"
        >
          <PrismicNextImage field={media.logo} className="h-6 w-6" />
        </PrismicNextLink>
      ))}
    </div>
  );
};

export default SocialMedia;
